module.exports = __webpack_public_path__ + "static/media/paypal-by-epoch-1.919bb64c.png";